import React from 'react';
import { CheckCircle2, CreditCard, TrendingUp, Shield, Clock, ArrowRight, Star, DollarSign } from 'lucide-react';

const EliteTradelinePackagePage = () => {
  const paymentLink = "https://www.fanbasis.com/agency-checkout/THEACADEMYCEO/r0mZW";

  return (
    <div className="dark-page">
      {/* Hero Section */}
      <section className="tradelines-hero">
        <div className="tradelines-hero-content">
          <div className="tradelines-badge">PREMIUM PACKAGE</div>
          <h1 className="display-huge tradelines-title">
            <span className="text-gradient">Elite Tradeline</span> Package
          </h1>
          <h2 style={{ color: 'var(--accent-gold)', fontSize: '28px', fontWeight: '600', margin: '15px 0 25px' }}>
            GUARANTEED $100K in Total Line Value
          </h2>
          <p className="body-large tradelines-subtitle" style={{ maxWidth: '750px', margin: '0 auto 30px' }}>
            Unlock access to our exclusive 100K Elite Tradeline Package, designed for individuals who want to establish stronger financial positioning and create opportunities for growth.
          </p>
          
          <div className="tradelines-features-row">
            <div className="tradeline-feature-item">
              <DollarSign size={24} />
              <span>$100K Total Value</span>
            </div>
            <div className="tradeline-feature-item">
              <Clock size={24} />
              <span>1-10 Year History</span>
            </div>
            <div className="tradeline-feature-item">
              <Shield size={24} />
              <span>Premium Selection</span>
            </div>
          </div>
        </div>
      </section>

      {/* Buy Now CTA */}
      <section style={{ padding: '40px 7.6923%', textAlign: 'center', background: 'var(--bg-primary)' }}>
        <a 
          href={paymentLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
          style={{ fontSize: '20px', padding: '20px 50px' }}
        >
          Buy Now <ArrowRight size={24} />
        </a>
      </section>

      {/* What You Get Section */}
      <section className="tradelines-grid-section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="section-header">
          <h2 className="display-medium section-title">What's Included</h2>
          <p className="body-medium section-description">
            Premium tradelines strategically engineered for maximum impact
          </p>
        </div>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div className="tradeline-card" style={{ borderColor: 'var(--accent-gold)' }}>
            <ul className="tradeline-card-features">
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>GUARANTEED $100K in Total Line Value</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Seasoned Lines with 1-10 Year History</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Strategic Account Mix for Maximum Impact</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Profile Depth & Stability Enhancement</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Posting Timeframe: 2-6 Weeks</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Exclusive Client Support & Guidance</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Lender-Ready Profile Positioning</span>
              </li>
              <li className="tradeline-feature">
                <CheckCircle2 size={16} />
                <span>Premium Tradeline Selection</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why This Package Section */}
      <section className="wealth-for-section">
        <div className="section-header">
          <h2 className="display-medium section-title">Why The Elite Package?</h2>
        </div>
        
        <div className="wealth-for-grid" style={{ maxWidth: '900px', margin: '30px auto 0' }}>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>High-value tradelines strategically added to your profile</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Showcase depth, stability, and long-standing credit history</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Demonstrate proven track record of responsible credit management</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Each line chosen for maximum impact on your credit profile</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Create the appearance of an established, creditworthy borrower</span>
          </div>
          <div className="wealth-for-item">
            <Star size={20} />
            <span>Years of positive history added to your profile</span>
          </div>
        </div>
      </section>

      {/* Who Is This For */}
      <section className="tradelines-grid-section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="section-header">
          <h2 className="display-medium section-title">Who Is This For?</h2>
        </div>
        
        <div className="wealth-for-grid" style={{ maxWidth: '800px', margin: '30px auto 0' }}>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>Entrepreneurs preparing for major funding applications</span>
          </div>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>Professionals seeking premium credit cards and loans</span>
          </div>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>Real estate investors positioning for investment property financing</span>
          </div>
          <div className="wealth-for-item">
            <TrendingUp size={20} />
            <span>Anyone looking to transform their credit profile from average to exceptional</span>
          </div>
        </div>
      </section>

      {/* Bottom Line Section */}
      <section className="wealth-for-section">
        <div className="section-header">
          <h2 className="display-medium section-title">The Bottom Line</h2>
          <p className="body-large section-description" style={{ maxWidth: '700px', margin: '20px auto 0' }}>
            The Elite Tradeline Package isn't just about adding tradelines — it's about strategically engineering your credit profile to open doors that were previously closed.
          </p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Ready to Go Elite?</h2>
          <p className="body-large" style={{ marginBottom: '30px', maxWidth: '600px', margin: '0 auto 30px' }}>
            Transform your credit profile with our premium $100K Elite Tradeline Package.
          </p>
          <a 
            href={paymentLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ fontSize: '18px', padding: '18px 40px' }}
          >
            Buy Now <ArrowRight size={24} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default EliteTradelinePackagePage;
